<template>
  <div>
    <Loading v-if="!isPageFullyLoaded" />
    <Portfolio @portfolio-loaded="isPageFullyLoaded = true" />
  </div>
</template>

<script>
import Loading from '@/views/loading'
const Portfolio = () => import('@/views/portfolio')

export default {
  name: 'Home',
  components: {
    Portfolio,
    Loading
  },
  data () {
    return {
      isPageFullyLoaded: false
    }
  }
}
</script>
